<template>
    <div>
        <div></div>
        <customer-list ref="cusList" pageUrl="customer/managepage" pageType=1></customer-list>
    </div>    
</template>

<style lang="less">

</style>

<script>
import CustomerList from './Customer-list.vue'

export default {
    components: { CustomerList },
}

</script>